@if (spinnerService.isLoading()) {

<div class="global-spinner-overlay">
    <div class="global-spinner-content">
        <div class="universal-loader">
            <div class="spinner-rings">
                <div class="ring ring-1"></div>
                <div class="ring ring-2"></div>
                <div class="ring ring-3"></div>
            </div>
            <div class="spinner-pulse"></div>
        </div>
        <p class="spinner-text">Cargando...</p>
    </div>
</div>
}
<ng-content></ng-content>